import { Rating } from "@mui/material";
import axios from "axios";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useParams } from "react-router-dom";
import "./ProductPage.css";
import actions from "../redux/actions/cartActions";
import { Toast, ToastContainer } from "react-bootstrap";
import { styled } from "@mui/material/styles";
import { Slide, Fade } from "react-awesome-reveal";
import SuggestedProducts from "../components/SuggestedProducts";

function ProductPage() {
  const [showImg, setShowImg] = useState(true);
  const [product, setProduct] = useState({});
  const [qty, setQty] = useState(1);
  const params = useParams();
  const dispatch = useDispatch();
  const [show, setShow] = useState(false);
  const cart = useSelector((state) => state.cart);

  const StyledRating = styled(Rating)({
    "& .MuiRating-iconFilled": {
      color: "#c7a43f",
    },
  });

  try {
    useEffect(() => {
      window.scrollTo(0, 0);
      const getProducts = async () => {
        const response = await axios({
          method: "get",
          url: `${process.env.REACT_APP_API_URL}/api/products/${params.productName}`,
        });
        setProduct(response.data);
      };
      getProducts();
    }, [params.productName]);
  } catch (err) {
    console.log(err);
  }

  const handleSubmit = async (e) => {
    e.preventDefault();

    dispatch(actions.addToCart(product, Number(qty), true));
    setShow(true);
  };
  return (
    <>
      {Object.keys(product).length > 0 && (
        <ToastContainer
          position="top-end"
          className="cart-popup-container p-3 pop-up-mt"
        >
          <Toast
            onClose={() => setShow(false)}
            show={show}
            delay={3000}
            bg="light"
            animation={true}
          >
            <Toast.Header>
              <img
                src="holder.js/20x20?text=%20"
                className="rounded me-2"
                alt=""
              />
              <p className="me-auto mb-0 py-2 f-roboto text-dark">
                JUST ADDED TO YOUR CART
              </p>
            </Toast.Header>
            <Toast.Body className="p-4">
              <div className="d-flex justify-content-between align-items-center mb-3">
                <img
                  src={
                    process.env.REACT_APP_IMAGES_URL + "/" + product.images.img1
                  }
                  alt={product.name}
                  className="cart-popup-img img-fluid"
                />
                <p className="px-3 m-0">{product.name}</p>

                <p>Qty:{qty}</p>
              </div>
              <Link to="/cart" className="btn btn-outline-yellow w-100 fs-7">
                VIEW CART ({cart.length})
              </Link>
              <Link
                to="/"
                className="d-flex justify-content-center mt-3 link-yellow"
              >
                Continue shopping
              </Link>
            </Toast.Body>
          </Toast>
        </ToastContainer>
      )}
      <div className="container position-relative product-page mb-5 animate__animated animate__fadeIn px-4">
        <div className="row">
          <div className="col-lg-6 p-0 d-flex flex-column">
            {Object.keys(product).length > 0 && (
              <>
                <div className="product-img ms-auto me-auto animate__animated animate__fadeIn">
                  <img
                    src={
                      process.env.REACT_APP_IMAGES_URL +
                      "/" +
                      product.images.img1
                    }
                    alt={product.name}
                    className={`${
                      showImg ? "d-block" : "d-none"
                    } img-fluid w-100 animate__animated animate__fadeIn product-img1`}
                  />
                  <img
                    src={
                      process.env.REACT_APP_IMAGES_URL +
                      "/" +
                      product.images.img2
                    }
                    alt={product.name}
                    className={`${
                      showImg ? "d-none" : "d-block"
                    } img-fluid w-100 animate__animated animate__fadeIn`}
                  />
                </div>
                <div className="d-flex flex-row mt-3">
                  <div
                    className={`col-6 me-2 image-snippet ${
                      showImg
                        ? "border border-3 border-dark rounded"
                        : "border-0"
                    }`}
                    onClick={() => {
                      setShowImg(true);
                    }}
                  >
                    <img
                      src={
                        process.env.REACT_APP_IMAGES_URL +
                        "/" +
                        product.images.img1
                      }
                      alt={product.name}
                      className="img-fluid w-100"
                    />
                  </div>
                  <div
                    className={`col-6 me-2 image-snippet ${
                      showImg
                        ? "border-0"
                        : "border border-3 border-dark rounded"
                    }`}
                    onClick={() => {
                      setShowImg(false);
                    }}
                  >
                    <img
                      src={
                        process.env.REACT_APP_IMAGES_URL +
                        "/" +
                        product.images.img2
                      }
                      alt={product.name}
                      className="img-fluid"
                    />
                  </div>
                </div>
              </>
            )}
          </div>
          <div className="col-lg-6 p-0 mt-4 mt-lg-0">
            <div>
              <h1 className="m-0 fs-3 fs-md-2 text-dark">{product.name}</h1>
              <p className="fw-bold fs-4 m-0">${product.price}</p>

              <div className="d-flex align-items-center mb-1 mt-3 mt-lg-2">
                <StyledRating
                  name="read-only"
                  value={product.rating}
                  readOnly
                />
                <span className="ms-2">3 Reviews</span>
              </div>
              <p>Shipping calculated at checkout.</p>
              <form onSubmit={handleSubmit} className="d-flex flex-column">
                <label htmlFor="quantity">Quantity</label>
                <input
                  type="number"
                  min="1"
                  name="quantity"
                  className="quantity-input mt-1 f-roboto"
                  onChange={(e) => setQty(e.target.value)}
                  value={qty}
                />
                <button
                  type="submit"
                  onClick={() => {
                    window.scrollTo(0, 0);
                  }}
                  className="btn btn-yellow mt-4 w-75"
                >
                  ADD TO CART
                </button>
              </form>
            </div>
            <p className="mt-5 fs-7">{product.description}</p>
            <p className="mt-2 fs-7">
              <strong>Interesting fact:</strong> Hot Cinnamon Spice is one of
              the oldest flavored tea blends that Harney & Sons has created.
              John Harney, Founder and Master Blender of Harney & Sons Fine Teas
              developed it in the beginning of the 1980s and since then the
              popularity has grown and keeps growing.
            </p>
            <p className="fs-7">
              <strong>Ingredients</strong>: Decaffeinated black tea, orange
              peel, three types of cinnamon, sweet cloves. Contains natural &
              artificial flavours.
            </p>
          </div>

          <Slide direction="up" triggerOnce="true" className="m-0 p-0">
            <Fade triggerOnce="true">
              <div className="col-12 border rounded px-3 reviews-box mb-5 text-responsive">
                <div className="border-bottom py-4 px-2">
                  <h2 className="fs-5 text-dark">CUSTOMER REVIEWS</h2>
                  <div className="d-flex align-items-center">
                    <StyledRating name="read-only" value={5} readOnly />
                    <span className="ms-2 f-roboto">Based on 3 reviews</span>
                  </div>
                </div>
                <div className="border-bottom py-4 px-2 d-flex flex-column">
                  <StyledRating name="read-only" value={5} readOnly />
                  <p className="mb-1 mt-3">This tea is great!</p>
                  <p className="f-roboto">
                    <strong>TastingTheBud</strong> on{" "}
                    <strong>Feb 01, 2022</strong>
                  </p>
                  <p className="f-roboto">
                    I tried this tea for the first time yesterday. The coconut
                    and vanilla give a very sweet and pleasant taste. The
                    lemongrass gives a delicate citrusy flavour to my tea and
                    the fact that it is a green tea, packed with antioxidants is
                    just amazing. It is now one of my favourite teas.
                  </p>
                  <Link to="/" className="text-dark ms-auto f-roboto fs-7">
                    Report as Inappropriate
                  </Link>
                </div>

                <div className="py-4 px-2 d-flex flex-column border-bottom">
                  <StyledRating name="read-only" value={5} readOnly />
                  <p className="mb-1 mt-3">Christmas gift</p>
                  <p className="f-roboto">
                    <strong>Karen Dunsmore</strong> on{" "}
                    <strong>Nov 16, 2021</strong>
                  </p>
                  <p className="f-roboto">
                    It's a Christmas gift so haven't tried it yet but thank you
                    for the sample tea bag it was lovely!
                  </p>
                  <Link to="" className="text-dark ms-auto f-roboto fs-7">
                    Report as Inappropriate
                  </Link>
                </div>

                <div className="py-4 px-2 d-flex flex-column">
                  <StyledRating name="read-only" value={5} readOnly />
                  <p className="mb-1 mt-3">Amazing flavour!</p>
                  <p className="f-roboto">
                    <strong>Samantha</strong> on <strong>Oct 03, 2021</strong>
                  </p>
                  <p className="f-roboto">
                    Second time I've ordered this tea. So refreshing, love the
                    coconut hint of flavour.
                  </p>
                  <Link to="" className="text-dark ms-auto f-roboto fs-7">
                    Report as Inappropriate
                  </Link>
                </div>
              </div>
            </Fade>
          </Slide>
          <div className="my-0 my-sm-5 px-4 text-center">
            <h4 className="my-4 my-sm-5 fs-5">YOU MAY ALSO LIKE</h4>
            {Object.keys(product).length > 0 && (
              <SuggestedProducts categorySlug={product.category.slug} />
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default ProductPage;
